import apiClient from './apiConfig';

const paymentService = {
  checkPaymentOptions: async (positionId, candidateId) => {
    const response = await apiClient.get('/payments/check-options', { 
      params: { positionId, candidateId } 
    });
    return response.data;
  },

  initiatePayment: async (paymentData) => {
    const response = await apiClient.post('/payments/initiate', paymentData);
    return response.data;
  },

  verifyPayment: async (txRef) => {
    const response = await apiClient.get(`/payments/verify/${txRef}`);
    return response.data;
  },

  getMyTransactions: async () => {
    const response = await apiClient.get('/payments/my-transactions');
    return response.data;
  },

  getAllTransactions: async (filters = {}) => {
    const response = await apiClient.get('/payments/transactions', { params: filters });
    return response.data;
  },

  getPaymentStats: async (positionId) => {
    const response = await apiClient.get(`/payments/stats`, { params: { positionId } });
    return response.data;
  },
};

export default paymentService;
